import React, { PropsWithChildren, useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { useScreenSize } from "utils/hooks/useScreenSize";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

type Props = {
	className: string
	tooltipId: string
}

function SingleProductPageTableCell({
	className = "",
	tooltipId,
	children,
}: PropsWithChildren<Props>) {

	const screenSize = useScreenSize();

	const cellRef = useRef<HTMLDivElement>(null)

	const isCellEllipsis = () => {
		if (!cellRef || !cellRef?.current || !cellRef?.current?.offsetWidth || !cellRef?.current?.scrollWidth) return false;
		return cellRef?.current?.offsetWidth < cellRef?.current?.scrollWidth;
	}

	const [ isEllipsis, toggleEllipsis ] = useState(isCellEllipsis())

	useEffect(() => {
		toggleEllipsis(isCellEllipsis());
	}, [ screenSize ]);

	return (
		<>
			<div
				ref={ cellRef }
				className={ classNames("relative" ,{ [ className ]: className }) }
				data-tooltip-id={ tooltipId }
			>
				{ children }
			</div>
			{
				isEllipsis &&
                <Tooltip id={ tooltipId } className="z-10">
					{ children }
                </Tooltip>
			}
		</>
	);
}

export default SingleProductPageTableCell;